<style lang="scss" scoped="custom">
  @import "./style.scss"
</style>

<template>
    <div class="custom noselect">
    	<top-header></top-header>
    	<keep-alive :include="getTabs">
    		<router-view/>
    	</keep-alive>
    	<bottom></bottom>
    </div>
</template>

<script>
import script from './script.js'
export default script
</script>



// WEBPACK FOOTER //
// src/views/custom/index.vue